import { computed, toValue } from "vue";
import { resultText } from "#ce/components/SpFinder/view-models/result-text";

/**
 * Returns the result card's labels: the finder copy for each attribute tile, overridden by any label `labels` sets.
 *
 * @param {Object|Function} labels the labels the card was handed
 * @param {Object} [extra] further defaults, such as a location's disclaimer
 */
export function useFinderResultLabels(labels, extra = {}) {
  return computed(() => ({
    acceptingPatients: resultText("accepting"),
    notAcceptingPatients: resultText("not_accepting"),
    lgbtqiaAffirmingCare: resultText("lgbtqia_affirming_care"),
    lgbtqiaAffirmingCareTooltip: resultText("lgbtqia_affirming_care_tooltip"),
    videoVisitsAvailable: resultText("video_visits_available"),
    ...toValue(extra),
    ...toValue(labels),
  }));
}
